import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarText,
  NavbarToggler,
  NavLink,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ReactComponent as Logo } from 'assets/images/svg/logo.svg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import styles from "./style.module.scss";
import { getUserData } from "utils/Session";
import CalculatorOffCanvas from "components/OffCanvas/CalculatorOffCanvas";
import ResendConfirmationOffCanvas from "components/OffCanvas/ResendConfirmation";
import cx from "classnames";

const NavMenu = props => {
  const ADMIN_PATH_PREFIX = "/admin"

  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith(ADMIN_PATH_PREFIX);
  const [isOpen, setIsOpen] = useState(false);

  const [userName, setUserName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [packageDropdownOpen, setPackageDropdownOpen] = useState(false);
  const togglePackageDropdown = () => setPackageDropdownOpen(!packageDropdownOpen);

  useEffect(() => {
    getUserName().then(n => {
      setUserName(n);
    })
  }, [])

  const getUserName = async () => {
    const userData = await getUserData();
    return userData.attributes?.name;
  }

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      {isAdmin && (
        <Navbar
          className={styles.mainNav}
          expand="md"
          light
        >
          <NavbarBrand className="col-4 col-sm-2" href="/">
            <Logo className={styles.logo} />
          </NavbarBrand>
          <NavbarToggler className={styles.toggler} onClick={toggle} />
          <Collapse isOpen={isOpen} className={styles.navBar} navbar>
            <Nav
              className="me-auto"
              navbar
            >
              <NavItem>
                <NavLink href="#" onClick={(e) => navigate("/admin/cargo-movements")}>
                  Bitacora
                </NavLink>
              </NavItem>
              <Dropdown nav isOpen={packageDropdownOpen} toggle={togglePackageDropdown}>
                <DropdownToggle nav caret>
                  Paqueteria
                </DropdownToggle>
                <DropdownMenu className={cx([styles.dropdownMenuLeftAling, styles.dropdownMenu])}>
                  <DropdownItem>
                    <NavLink href="#" onClick={(e) => navigate("/admin/poboxes")}>
                      Casilleros
                    </NavLink>
                    <NavLink href="#" onClick={(e) => navigate("/admin/packages")}>
                      Paquetes
                    </NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <NavItem>
                <NavLink href="#" onClick={(e) => navigate("/admin/prices")}>
                  Precios
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#" onClick={(e) => navigate("/admin/routes")}>
                  Rutas
                </NavLink>
              </NavItem>
              <NavItem>
                <CalculatorOffCanvas
                  wrapper={NavLink}>
                  Calculadora
                </CalculatorOffCanvas>
              </NavItem>
              <NavItem>
                <ResendConfirmationOffCanvas
                  wrapper={NavLink}>
                  Reenvio Confirmacion
                </ResendConfirmationOffCanvas>
              </NavItem>
            </Nav>
            <NavbarText>
              <Nav
                navbar
              >
                <Dropdown nav isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle className={styles.dropdownToggle} nav caret>
                    <AccountCircleIcon className={styles.profileIcon} />
                    {userName}
                  </DropdownToggle>
                  <DropdownMenu className={styles.dropdownMenu}>
                    <DropdownItem>
                      <NavLink href="#" onClick={(e) => navigate("/auth/logout")}>
                        Cerrar Session
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Nav>
            </NavbarText>
          </Collapse>
        </Navbar>
      )}
    </>
  );
}
export default NavMenu;